import red from 'material-ui/colors/red'

export default theme => ({

  card: {
    display: 'inline-block',
    width: theme.spacing.unit * 55,
    marginTop: '10vh',
    backgroundColor: red[100],
    color: red[800]
  }

})



// WEBPACK FOOTER //
// ./src/styles/pages/auth/confirm/error.js